module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"title":"SaaS сервисы","newServer":"Новая услуга","createServer":"Оформить новую услугу","stacklink1":{"title":"разделе","text":"Завести плательщика в этом"},"stacklink2":{"title":"тут","text":"Добавить верифицированный номер телефона"},"empty":{"title":"На данный момент у вас нет ни одной активной услуги \\"SaaS сервисы\\"","text":"SaaS сервисы"}}}')
  delete Component.options._Ctor
}
